import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import StoryCard from "../../shared/StoryCard";
import { filterCards, isPartnershipCard } from "../../shared/card-utils";
import UserTypeSelection from "../../../molecules/UserTypeSelection";
import LoadingIndicatorComponent from "../../../atoms/loading-indicator";
import { SignInModal } from "../../../layouts/header/sign-in-modal";

import "../../text-story/text-story.m.css";

/**
 * Renders cards with partnership style tracking
 * @param {Array} cards - Cards to render
 * @param {Object} story - The story object
 * @returns {Array} Array of StoryCard elements
 */
const renderCardsWithPartnershipTracking = (cards, story) => {
  const elements = [];
  let prevWasPartnership = false;

  cards.forEach((card, index) => {
    const applyPartnershipStyle = prevWasPartnership;
    prevWasPartnership = isPartnershipCard(card);

    elements.push(
      <StoryCard
        key={card.id || index}
        card={card}
        cardIndex={index}
        story={story}
        applyPartnershipStyleToFirstTitle={applyPartnershipStyle}
      />
    );
  });

  return elements;
};

const PremiumArticleBody = ({
  story,
  subscriptionPlans = [],
  initRazorPayPayment,
  getSubscriptionForUser,
  accessTypeBkIntegrationId,
  member,
  hasUserPurchasedStory = false,
  isPPACheckComplete = false,
}) => {
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const cards = get(story, ["cards"], []);
  const { regularCards } = filterCards(cards);

  const handleSignInClick = () => setIsSignInModalOpen(true);
  const handleSignInModalClose = () => setIsSignInModalOpen(false);

  const renderContent = () => {
    const previewCards = regularCards.slice(0, 2);

    // If PPA check not complete, show preview cards with loading indicator
    if (!isPPACheckComplete) {
      return [
        ...renderCardsWithPartnershipTracking(previewCards, story),
        <LoadingIndicatorComponent key="ppa-loading" />,
      ];
    }

    // If user has purchased, show all cards
    if (hasUserPurchasedStory) {
      return renderCardsWithPartnershipTracking(regularCards, story);
    }

    // User hasn't purchased - show preview cards with UserTypeSelection
    const cardElements = renderCardsWithPartnershipTracking(previewCards, story);

    cardElements.push(
      <UserTypeSelection
        key="user-type-selection"
        plans={subscriptionPlans}
        story={story}
        initRazorPayPayment={initRazorPayPayment}
        getSubscriptionForUser={getSubscriptionForUser}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
        member={member}
        onSignInClick={handleSignInClick}
      />
    );

    return cardElements;
  };

  return (
    <>
      <div styleName="article-body">{renderContent()}</div>
      <SignInModal isOpen={isSignInModalOpen} onClose={handleSignInModalClose} />
    </>
  );
};

PremiumArticleBody.propTypes = {
  story: PropTypes.object.isRequired,
  subscriptionPlans: PropTypes.array,
  initRazorPayPayment: PropTypes.func,
  getSubscriptionForUser: PropTypes.func,
  accessTypeBkIntegrationId: PropTypes.string,
  member: PropTypes.object,
  hasUserPurchasedStory: PropTypes.bool,
  isPPACheckComplete: PropTypes.bool,
};

export default PremiumArticleBody;
